import { render, staticRenderFns } from "./CommonList.vue?vue&type=template&id=10a3a1ee&scoped=true"
import script from "./CommonList.vue?vue&type=script&lang=ts"
export * from "./CommonList.vue?vue&type=script&lang=ts"
import style0 from "./CommonList.vue?vue&type=style&index=0&id=10a3a1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3a1ee",
  null
  
)

export default component.exports